import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Space Functionalization Entry: The association(s) between space functional usage and space, categorizing how space is used (e.g., research, administration, instruction).',
    name: 'Space Functionalization',
    partialId: PartialId.Standard.create('space_funcl'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
